import React, { useEffect } from "react";
import LevelTable from "../tables/LevelTable";
import { Button, CircularProgress } from "@mui/joy";
import DynamicAddModal from "../DynamicComponents/DynamicAddModal";
import { ApiService } from "../../api/ProjectInfoService";
import { ToastContainer, toast } from "react-toastify";
import DisciplineCodesAddModal from "./DisciplineCodesAddModal";
import { Toast } from "@fluentui/react-components";

interface ThemaBoxProps {
  title: string;
  project: any;
  email: string;
  userIsPrivileged: boolean;
}

const ThemaBox = ({
  title,
  project,
  email,
  userIsPrivileged,
}: ThemaBoxProps) => {
  const [openAddModalDisciplineCode, setOpenAddModalDisciplineCode] = React.useState<boolean>(false);
  const [openAddThemaModal, setOpenAddThemaModal] = React.useState<boolean>(false);
  const [openAddFocuslijnModal, setOpenAddFocuslijnModal] = React.useState<boolean>(false);
  const [themeCategories, setThemeCategories] = React.useState<any[]>([]);
  const [themeSubCategories, setThemeSubCategories] = React.useState<any[]>([]);
  const [focusLijnen, setFocuslijnen] = React.useState<any[]>([]);
  const [focusLijnenCategory, setFocusLijnenCategory] = React.useState<any[]>(
    []
  );
  const [focusLijnenSub, setFocusLijnenSub] = React.useState<any[]>([]);
  const [themes, setThemes] = React.useState<any[]>([]);
  const [disciplineCodes, setDisciplineCodes] = React.useState<any[]>([]);

  useEffect(() => {
    ApiService.getThemes()
      .then((res) => {
        // only show Blikoperner and Duurzame ontwikkelingsdoelstellingen
        setThemeCategories(
          res.data.filter(
            (a: any) =>
              a.parent === null &&
              a.isActive &&
              a.id !== "c4aeeb94-67a4-4918-b696-4b6be98d64a5"
          )
        );
        setThemeSubCategories(
          res.data.filter((a: any) => a.parent !== null && a.isActive)
        );
        setFocusLijnenCategory(
          res.data.filter(
            (a: any) =>
              a.parent === null &&
              a.isActive &&
              a.id === "c4aeeb94-67a4-4918-b696-4b6be98d64a5"
          )
        );
        setFocusLijnenSub(
          res.data.filter(
            (a: any) =>
              a.parent === "c4aeeb94-67a4-4918-b696-4b6be98d64a5" &&
              a.isActive
          )
        );
        setThemes(
          excludeFocusLijnFromFilter(
            project?.themes?.models,
            res.data.filter((a: any) => a.parent !== null && a.isActive)
          )
        );
        setFocuslijnen(
          includeFocusLijnFromFilter(
            project?.themes?.models,
            res.data.filter((a: any) => a.parent !== null && a.isActive)
          )
        );

      })
      .catch((error) => {
        console.log(error);
        toast.error("Er is iets misgegaan bij het ophalen van de thema's");
      });

    ApiService.getDisciplineCodes()
      .then((res) => {
        setDisciplineCodes(res.data);
      })
      .catch((error) => {
        toast.error(
          "Er is iets misgegaan bij het ophalen van de disciplinecodes"
        );
      });
  }, []);


  const handleSaveDisciplineCodes = (data: any) => {
    // map data to correct format
    const mappendata = {
      kindid: data.category.id,
      subKindid: data.subCategory.id,
      typeid: data.type.id,
      subTypeid: data.subType.id,
      projectDospId: project.dospId,
    };
    setOpenAddModalDisciplineCode(false);
    ApiService.postDisciplineCodes(mappendata)
      .then((res) => {
        toast.success("Disciplinecodes succesvol aangevraagd om toe te voegen");
      })
      .catch((error: any) => {
        toast.error(
          "Er is iets misgegaan bij het toevoegen van de disciplinecodes"
        );
      });
  };

  const handleSaveThemes = (data: any) => {
    // map data to correct format
    const mappendata = {
      kindid: data.ThemaCategorie?.id,
      subKindid: data.ThemaSubCategorie?.id,
      projectDospId: project.dospId,
    };
    setOpenAddThemaModal(false);
    ApiService.postThemes(mappendata)
      .then((res) => {
        toast.success("Thema's succesvol aangevraagd om toe te voegen");

      })
      .catch((error) => {
        toast.error("Er is iets misgegaan bij het toevoegen van de thema's");
      });
  };

  const handleSaveFocuslijnen = (data: any) => {
    // map data to correct format
    const mappendata = {
      kindid: data.FocuslijnCategorie?.id,
      subKindid: data.FocuslijnSubCategorie?.id,
      projectDospId: project.dospId,
    };
    setOpenAddFocuslijnModal(false);
    ApiService.postFocuslines(mappendata)
      .then((res) => {
        toast.success("Focuslijnen succesvol aangevraagd om toe te voegen");
        setOpenAddFocuslijnModal(false);
      })
      .catch((error) => {
        toast.error("Er is iets misgegaan bij het toevoegen van de focuslijnen");
      });
  };

  if (themeCategories.length === 0 && themeSubCategories.length === 0 && focusLijnenCategory.length === 0 && focusLijnenSub.length === 0 && themes.length === 0 && disciplineCodes.length === 0)
    return (
      //loading spinner icon
      <div className="loadingCircle">
        <CircularProgress
          size="lg"
          sx={{
            "--CircularProgress-trackColor": "#484494",
            "--CircularProgress-progressColor": "#b6b4d4",
          }}
        />
      </div>
    );

  return (
    <>
    <div className="box">
      <div className="headerLeden">
        <h2>Disciplinecodes</h2>
        {userIsPrivileged && (
          <DisciplineCodesAddModal
            isOpen={openAddModalDisciplineCode}
            onClose={() => setOpenAddModalDisciplineCode(false)}
            onSave={handleSaveDisciplineCodes}
            options={disciplineCodes}
            values={[
              { label: "Categorie", value: "", codeLength: 2 },
              { label: "Sub Categorie", value: "", codeLength: 4 },
              { label: "Type", value: "", codeLength: 6 },
              { label: "Sub Type", value: "", codeLength: 8 },
            ]}
          />
        )}
        {userIsPrivileged && (
          <Button
            id="addButton"
            variant="outlined"
            color="neutral"
            sx={{ backgroundColor: "#484494" }}
            onClick={() => setOpenAddModalDisciplineCode(true)}
          >
            Toevoegen
          </Button>
        )}
      </div>
      <LevelTable
        columns={[
          { id: 1, label: "Categorie", property: "category.name" },
          { id: 2, label: "Sub Categorie", property: "subCategory.name" },
          { id: 3, label: "Type", property: "type" },
          { id: 4, label: "Sub Type", property: "subtype.name" },
        ]}
        data={project?.disciplineCodes?.models}
      />
    </div>
      <div className="box">
        {userIsPrivileged && (
          <DynamicAddModal
            key={"thema"}
            isOpen={openAddThemaModal}
            onClose={() => setOpenAddThemaModal(false)}
            onSave={handleSaveThemes}
            values={[
              {
                label: "Thema Categorie",
                value: "",
                options: themeCategories,
                child: {
                  label: "Thema Sub Categorie",
                  value: "",
                  options: themeSubCategories,
                },
              },
            ]}
          />
        )}
        <div className="headerLeden">
          <h2>Thema's</h2>
          {userIsPrivileged && (
            <Button
              id="addButton"
              variant="outlined"
              color="neutral"
              sx={{ backgroundColor: "#484494" }}
              onClick={() => setOpenAddThemaModal(true)}
            >
              Toevoegen
            </Button>
          )}
        </div>
        <LevelTable
          columns={[
            { id: 1, label: "Categorie", property: "category.name" },
            { id: 2, label: "Sub Categorie", property: "subCategory.name" },
          ]}
          data={themes}
        />
      </div>
      <div className="box">
        {userIsPrivileged && (
          <DynamicAddModal
          key={"focuslijn"}
            isOpen={openAddFocuslijnModal}
            onClose={() => setOpenAddFocuslijnModal(false)}
            onSave={handleSaveFocuslijnen}
            values={[
              {
                label: "Focuslijn Categorie",
                value: "Focuslijnen",
                options: focusLijnenCategory,
                child: {
                  label: "Focuslijn Sub Categorie",
                  value: "",
                  options: focusLijnenSub,
                },
              },
            ]}
          />
        )}
        <div className="headerLeden">
          <h2>Focuslijnen</h2>
          {userIsPrivileged && (
            <Button
              id="addButton"
              variant="outlined"
              color="neutral"
              sx={{ backgroundColor: "#484494" }}
              onClick={() => setOpenAddFocuslijnModal(true)}
            >
              Toevoegen
            </Button>
          )}
        </div>
        <LevelTable
          columns={[
            { id: 1, label: "Categorie", property: "category.name" },
            { id: 2, label: "Sub Categorie", property: "subCategory.name" },
          ]}
          data={focusLijnen}
        />
      </div>
      <ToastContainer />
    </>
  );
};

export default ThemaBox;


function excludeFocusLijnFromFilter(themes: any, subCategories: any) {
  const excludeFocuslijn = "c4aeeb94-67a4-4918-b696-4b6be98d64a5";
  let filteredThemes = themes.filter(
    (a: any) =>
      a.isActive && a.id !== excludeFocuslijn
  );

  let filteredSubCategories = subCategories.filter(
    (a: any) =>
      a.isActive && a.parent ===excludeFocuslijn
  );

  let themesToRemove: any[] = [];
  filteredSubCategories.forEach((subCat: any) => {
    // find the parent of the subcategory in the filtered themes

    themes.forEach((theme: any) => {
      if (subCat.id === theme.id) {

        themesToRemove.push({ category: theme, subCategory: subCat });
      }
      return;
    });
  });
  return filteredThemes.filter((theme: any) => {
    return !themesToRemove.some(
      (remove: any) => remove.category.id === theme.id
    );
  });
}

function includeFocusLijnFromFilter(themes: any, subCategories: any){
  const includeFocuslijn = "c4aeeb94-67a4-4918-b696-4b6be98d64a5";

  let filteredSubCategories = subCategories.filter(
    (a: any) =>
      a.isActive && a.parent ===includeFocuslijn
  );

  let themestoInclude: any[] = [];
  filteredSubCategories.forEach((subCat: any) => {
    // find the parent of the subcategory in the filtered themes

    themes.forEach((theme: any) => {
      if (subCat.id === theme.id) {
        themestoInclude.push(theme);
      }
      return;
    });
  });

  let filteredThemes = themes.filter(
    (a: any) =>
      a.isActive && a.id === includeFocuslijn
  );
  return themestoInclude.concat(filteredThemes);
}
